import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './App.css';

function Header() {
    const location = useLocation();
    const hiddenRoutes = ['/privacy_policy'];

    if (hiddenRoutes.includes(location.pathname)) {
        return null;
    }

    return (
        <header className="app-header">
            <div className="logo">
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <h2>DestanGlobal</h2>
                </Link>
            </div>
            <nav className="nav-buttons">
                {/* <Link to="/" className={`nav-btn ${location.pathname === '/' ? 'active' : ''}`}>
                    Home
                </Link> */}

                {/* <Link to="/privacy_policy" className={`nav-btn ${location.pathname === '/privacy_policy' ? 'active' : ''}`}>
                    Privacy Policy
                </Link> */}
                <Link to="/contact_us" className={`nav-btn ${location.pathname === '/contact_us' ? 'active' : ''}`}>
                    Contact Us
                </Link>
            </nav>
        </header>
    );
}

export default Header;
